import { gql } from '@apollo/client';

export const query = gql`
  query useQueryRoles {
    auth0_roles {
      id
      name
      description
    }
  }
`;
